var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-f",attrs:{"id":"public"}},[_c('div',{staticClass:"p45"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }